import styled from "styled-components";
import {
  Box,
  Button,
  Card,
  CardActions,
  Stack,
  Typography,
  TextField,
} from "@mui/material";
import { theme } from "styles/mui-config";

export const StyledButton = styled(Button)`
  &:nth-last-child(1) {
    border-bottom: none !important;
  }
  background: transparent;
  border: none;
  outline: none;
  font-family: "IRANSans";
  cursor: pointer;
  width: 100%;
  padding: 10px;
  font-size: 0.85rem !important;
  padding: 10px !important;
  color: ${(props) =>
    props.selected ? theme.palette.primary.main : "#464646"} !important;
  background-color: ${(props) =>
    props.selected ? "rgba(22, 138, 251, 0.04)" : "none"} !important;
  border-bottom: 1px solid #e1e1e1 !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
`;

export const StyledTextField = styled(TextField)`
 
  & fieldset {
    border-top: none;
    border-left: none;
    border-right: none;
    border-radius: 0;
  }
  
`;

export const StyledSticky = styled.div`
  position: sticky !important;
  top: 24px;
 
  @media (max-width: 900px) {
    position: relative !important;
    top: 0px;
  }
`;

export const StyledRightIcon = styled.img`
  width: 70% !important;
  height: 70% !important;
`;

export const CategoryList = styled(Stack)`
  // position: sticky !important;
  // top: 84px;
  margin-top: 24px;
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 0px 17px rgba(158, 158, 158, 0.2);
  border-radius: 8px;
  margin-bottom: 20px;
  padding: 10px;
  align-items: center;
  overflow: hidden;
  & hr {
    width: 100%;
  }
  position: relative;
`;

export const BorderTop = styled.div`
  background: ${theme.palette.primary.main};
  border-radius: 50%;
  height: 10px;
  position: absolute;
  top: -6px;
  left: 40%;
  width: 20%;
`;
